module.exports = __webpack_public_path__ + "static/img/active6.d8acfb04.png";